import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Eye, MapPin } from 'lucide-react';
import { Button } from '../ui/button';
import { serviceAreas } from '../../data/mock';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_c3-refresh/artifacts/t578skzx_DJI_0618-HDR-1.jpg"
          alt="C3 Contracting construction site"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/80 to-slate-900/60" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full opacity-10">
        <div className="absolute top-20 right-20 w-96 h-96 bg-cyan-500 rounded-full blur-3xl" />
        <div className="absolute bottom-40 right-40 w-64 h-64 bg-yellow-400 rounded-full blur-3xl" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-40 pb-32">
        <div className="max-w-3xl">
          {/* Service Areas Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <MapPin className="w-4 h-4 text-cyan-400" />
            <span className="text-sm text-slate-300">Serving Concord, Davidson, Mooresville, Lake Norman & Surrounding Areas</span>
          </div>

          {/* Headline with Design+Build graphic */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Your Premier<br />
            <span className="inline-flex items-center gap-3">
              <img 
                src="https://customer-assets.emergentagent.com/job_c3admin-portal/artifacts/eo2e68tb_Design%2BBuild%20%28Wide%20-%20Dark%29.png" 
                alt="Design + Build" 
                className="h-[52px] sm:h-[64px] lg:h-[76px]"
                style={{ filter: 'brightness(0) saturate(100%) invert(76%) sepia(45%) saturate(1000%) hue-rotate(140deg) brightness(95%) contrast(90%)' }}
              />
              <span className="text-cyan-400">Team</span>
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-slate-300 leading-relaxed mb-10 max-w-2xl">
            Leaders in bringing your vision from dream to reality, combining innovative design, expert craftsmanship, and seamless project execution.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/consultation">
              <Button
                size="lg"
                className="bg-cyan-600 hover:bg-cyan-700 text-white font-semibold px-8 py-6 text-lg group"
              >
                Start Your Project
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/portfolio">
              <Button
                variant="outline"
                size="lg"
                className="border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg"
              >
                <Eye className="mr-2 w-5 h-5" />
                View Our Work
              </Button>
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-3 gap-4 sm:flex sm:items-center sm:gap-8 mt-12 pt-12 border-t border-white/10">
            <div className="text-center sm:text-left">
              <p className="text-2xl sm:text-3xl font-bold text-white">20+ Years</p>
              <p className="text-slate-300 text-xs sm:text-base">Construction Experience</p>
            </div>
            <div className="hidden sm:block h-12 w-px bg-white/20" />
            <div className="text-center sm:text-left">
              <p className="text-2xl sm:text-3xl font-bold text-white">3 Years</p>
              <p className="text-slate-300 text-xs sm:text-base">No Workplace Injuries</p>
            </div>
            <div className="hidden sm:block h-12 w-px bg-white/20" />
            <div className="text-center sm:text-left">
              <p className="text-2xl sm:text-3xl font-bold text-white">$1M+</p>
              <p className="text-slate-300 text-xs sm:text-base">Project Capacity</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
